var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 3.5H8.75C8.55109 3.5 8.36032 3.57902 8.21967 3.71967C8.07902 3.86032 8 4.05109 8 4.25V8H4.25C4.05109 8 3.86032 8.07902 3.71967 8.21967C3.57902 8.36032 3.5 8.55109 3.5 8.75V20.75C3.5 20.9489 3.57902 21.1397 3.71967 21.2803C3.86032 21.421 4.05109 21.5 4.25 21.5H16.25C16.4489 21.5 16.6397 21.421 16.7803 21.2803C16.921 21.1397 17 20.9489 17 20.75V17H20.75C20.9489 17 21.1397 16.921 21.2803 16.7803C21.421 16.6397 21.5 16.4489 21.5 16.25V4.25C21.5 4.05109 21.421 3.86032 21.2803 3.71967C21.1397 3.57902 20.9489 3.5 20.75 3.5ZM15.5 20H5V9.5H15.5V20ZM20 15.5H17V8.75C17 8.55109 16.921 8.36032 16.7803 8.21967C16.6397 8.07902 16.4489 8 16.25 8H9.5V5H20V15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7c836e012106058894a5d0fed60d94d1.svg";
export { ForwardRef as ReactComponent };